// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "./controllers";

// Prevent scroll from changing values in number inputs (browser default behaviour).
// Blurring the focused input on wheel suppresses the increment/decrement without
// interfering with normal page scrolling (listener is passive).
document.addEventListener(
  "wheel",
  () => {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement && el.type === "number") {
      el.blur();
    }
  },
  { passive: true },
);
